export enum Role {
  Manager = 'Manager',
  User = 'User',
  Admin = 'Admin',
  Default = 'Default'
}
